import api from '@/utils/api'

export interface SystemStats {
  totalUsers: number
  totalQuestionBanks: number
  totalQuestions: number
  totalSessions: number
  completedSessions: number
  activeUsers: number
}

export interface RecentActivity {
  id: number
  type: string
  user: {
    id: number
    username: string
    firstName: string
  }
  questionBank: {
    id: number
    domain: string
    subdomain: string
  }
  status: string
  score: number
  startedAt: string
  completedAt?: string
}

export interface PopularQuestionBank {
  questionBankId: number
  domain: string
  subdomain: string
  completedSessionCount: number
  uniqueUserCount: number
}

export interface ErrorProneQuestion {
  questionId: number
  questionBankId: number
  questionBankName: string
  question: string
  questionType: string
  answerCount: number
  incorrectAnswerCount: number
  errorRate: number
}

export interface QuestionBankAnalytics {
  popularQuestionBanks: PopularQuestionBank[]
  errorProneQuestions: ErrorProneQuestion[]
}

export interface QuestionBankAnalyticsPeriods {
  popularDays?: 1 | 7 | 30
  errorProneDays?: 1 | 7 | 30
}

export const adminApi = {
  // 获取系统统计数据
  async getSystemStats(): Promise<SystemStats> {
    const response = await api.get('/users/admin/stats')
    return response.data
  },

  // 获取最近活动
  async getRecentActivities(): Promise<RecentActivity[]> {
    const response = await api.get('/users/admin/recent-activities')
    return response.data
  },

  // 获取题库使用量与易错题统计
  async getQuestionBankAnalytics(
    periods: QuestionBankAnalyticsPeriods = {},
  ): Promise<QuestionBankAnalytics> {
    const response = await api.get('/admin/question-bank-analytics', {
      params: periods,
    })
    return response.data
  },
}
